export const enum PrivacyState {
  Public = 'public',
  Private = 'private',
}

export enum EffectivePrivacy {
  EffectivelyPublic = 'whole_workspace',
  EffectivelyPrivate = 'some_but_not_all',
}

export const effectivePrivacyMap = {
  some_but_not_all: EffectivePrivacy.EffectivelyPrivate,
  whole_workspace: EffectivePrivacy.EffectivelyPublic,
}
